import { render, staticRenderFns } from "./card-items-sowhatbuy.vue?vue&type=template&id=40238043&scoped=true&"
import script from "./card-items-sowhatbuy.vue?vue&type=script&lang=js&"
export * from "./card-items-sowhatbuy.vue?vue&type=script&lang=js&"
import style0 from "./card-items-sowhatbuy.vue?vue&type=style&index=0&id=40238043&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40238043",
  null
  
)

export default component.exports